import React, { useEffect, useState, useRef } from "react";
import {
    ButtonContain,
    Card,
    CardContain
} from '../../style/Home'
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TablePagination,
    MenuItem,
    Menu,
    Button,
    TextField,
    FormControl,
    Select,
} from "@mui/material";
import { CommanTableContainHierachyMaster } from "../../style/table";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GuidelineContain } from "../../style/AM/MoMStatusUpdate"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useDispatch, useSelector } from 'react-redux';
import { SmartSearchContain } from '../../style/table';
import SearchIcon from "@mui/icons-material/Search";
import { GetAiList, GetHierarchyMaster, ReassignAi, ImportExcelFile, GetExcelFile } from "../../services/hierarchyMasterService";
import { ContainerCustomDealerMaster } from '../../style/table';
import _ from 'lodash';
import { resetFilter } from "../../features/filterSlice";
import { toast } from "react-toastify";
import excelFile from "../../../src/assets/templates/Hierarchy_Template.xlsx"
import "react-toastify/dist/ReactToastify.css";
import ExcelIcon from "../../assets/images/icons/excel.png";

const HierachyMaster = () => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [filterValues, setFilterValues] = useState({});
    const [aiModalOpen, setAiModalOpen] = useState(false);
    const Drawer = useSelector((state) => state.drawer);
    const [isSelected, setIsSelected] = useState(false);
    const [resetTrigger, setResetTrigger] = useState(Date.now());
    const filtersValue = useSelector((state) => state.filterData);
    const [hierarchyData, setHierarchyData] = useState([]);
    const [search, setSearch] = useState("");
    const [aiData, setAiData] = useState([])
    const [searchAiByCode, setSearchAiByCode] = useState('')
    const [searchAiByName, setSearchAiByName] = useState('')
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    const [totalData, setTotalData] = useState(0);
    const [isDispatched, setIsDispatched] = useState(false)
    const [isreset, setReset] = useState(false)
    const [loader, setLoader] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [anchorE2, setAnchorE2] = useState(null);
    const openDownload = Boolean(anchorE2);
    const dispatch = useDispatch();
    const totalAi = useRef([]);
    const excelInputRef = useRef(null);


    const [fileType, setFileType] = useState("");

    const handleDownloadFile = async (mimeType) => {
        if(!mimeType){
            toast.warning("Excel type not found.");
            return;
        }
        try {
            const payload = {
                mimeType,
            };

            const response = await GetExcelFile({
                payload: payload,
            });

            if (response?.success && response?.url) {
                const link = document.createElement("a");
                link.href = response.url;
                link.target = "_blank";
                link.rel = "noopener noreferrer";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (error) {
            console.error("Download failed:", error);
            toast.error("Network Error");
        } finally {
            setFileType("");
        }
    };

    const getDealerList = async () => {
        try {
            const res = await GetAiList()
            if (res.success) {
                setAiData(res.data)
                totalAi.current = res.data
            }
        } catch (error) {
            console.log('error: ', error);
            console.log('Error on fetching mvr table data');
        }
    }

    useEffect(() => {
        getDealerList()
    }, [])


    useEffect(() => {
        dispatch(resetFilter());
        setIsDispatched(true)
    }, [dispatch]);

    const getHierarchyMaster = async () => {
        try {
            let payload = {
                "search": debouncedSearchTerm,
                "page": page,
                "offset": rowsPerPage
            }
            const res = await GetHierarchyMaster({ payload });
            if (res.success) {
                setHierarchyData(res?.data ?? [])
                setTotalData(res?.total ?? 0)
            }
        } catch (error) {
            console.log('Error on fetching mvr table data');
        }
    }

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchTerm(search);
        }, 600);

        return () => clearTimeout(handler);
    }, [search]);


    useEffect(() => {
        getHierarchyMaster()
    }, [rowsPerPage, page, debouncedSearchTerm]);

    const mvrTableCols = [
        "Dealer Code",
        "Dealer Name",
        "AM Code",
        "AM Name",
        "ZM Code",
        "ZM Name",
        "RM Code",
        "RM Name",
    ];
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleDownloadClose = () => {
        setAnchorE2(null);
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleDownloadOpen = (event) => {
        setAnchorE2(event.currentTarget);
    };

    const handleExcelFile = async (e) => {
        e.preventDefault();
        const file = e.target.files[0];

        if (!file) {
            toast.error("Please upload a file");
            return;
        }
        const formData = new FormData()
        formData.append("hierarchyMaster", file)

        try {
            setLoader(true)
            const res = await ImportExcelFile({ payload: formData })
            if (res.success) {
                toast.success("File Upload Successfully")
                await getHierarchyMaster();
            }
        } catch (error) {
            console.log("error:", error);
            if (error.code === "ERR_BAD_REQUEST") {
                toast.error(error?.response?.data?.error);
            }
            else {
                toast.error(error?.response?.data?.error)
            }
        } finally {
            setTimeout(() => {
                setLoader(false);
            }, 1000)
        }
    }

    useEffect(() => {
        const data = totalAi?.current ? totalAi.current : []
        if (searchAiByCode) {
            const filteredData = data?.filter(item => item.aiCode.includes(searchAiByCode))
            setAiData(filteredData)
        } else {
            setAiData(data)
        }

    }, [searchAiByCode])

    useEffect(() => {
        const data = totalAi?.current ? totalAi.current : [];
        if (searchAiByName) {
            const filteredData = data?.filter(item =>
                item.aiName.toLowerCase().includes(searchAiByName.toLowerCase())
            );
            setAiData(filteredData);
        } else {
            setAiData(data);
        }
    }, [searchAiByName]);


    return (
        <>
            <CardContain>
                <Card mt={2}>
                    <ContainerCustomDealerMaster>
                        <div className="import_btn">
                            <Button
                                variant="contained"
                                onClick={handleClick}
                                endIcon={<KeyboardArrowDownIcon />}
                            > Import
                            </Button>
                            <Menu
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                disableScrollLock
                            >
                                <a href={excelFile} download='HierarchyMaster.xlsx'>
                                    <MenuItem onClick={() => {
                                        handleClose();
                                    }}>Get Template</MenuItem>
                                </a>
                                <MenuItem
                                    onClick={() => {
                                        excelInputRef.current.value = "";
                                        excelInputRef.current.click();
                                        handleClose();
                                    }}
                                > Upload Excel
                                </MenuItem>
                            </Menu>
                        </div>
                        <div className="import_btn import_btn_xcel">
                            <SmartSearchContain >
                                <TextField
                                    label="Search"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    marginleft="auto"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                                <SearchIcon />
                            </SmartSearchContain>

                            <input
                                type="file"
                                style={{ display: "none" }}
                                ref={excelInputRef}
                                accept=".csv, .xls, .xlsx"
                                onChange={handleExcelFile}
                            />
                            {/* download file */}
                            <FormControl sx={{ minWidth: 70, }} size="small" >
                            <Button
                                    variant="contained"
                                    onClick={handleDownloadOpen}
                                    endIcon={<KeyboardArrowDownIcon />}
                                >
                                    <img src={ExcelIcon} alt="Excel icon" />
                                </Button>
                                <Menu
                                    anchorEl={anchorE2}
                                    open={openDownload}
                                    onClose={handleDownloadClose}
                                    disableScrollLock
                                >
                                    <MenuItem onClick={()=> handleDownloadFile("csv")}>
                                        Download CSV
                                    </MenuItem>
                                    <MenuItem onClick={() => handleDownloadFile("xlsx")}>
                                        Download Excel
                                    </MenuItem>
                                </Menu>
                            </FormControl>
                        </div>
                    </ContainerCustomDealerMaster>
                    <GuidelineContain style={{ marginLeft: "auto" }}>
                        <div className="Guidelines" >
                            <p>
                                <span>Guidelines : </span>
                                All of the hierarchy should be upload at once.
                            </p>
                        </div>
                    </GuidelineContain>
                    <CommanTableContainHierachyMaster>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {mvrTableCols.map((text, index) => (
                                        <TableCell key={index}>{text}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {hierarchyData.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{row.dealerCode}</TableCell>
                                        <TableCell>{row.dealerName}</TableCell>
                                        {/* <TableCell>{row.networkType}</TableCell>
                                        <TableCell>{row.networkCode}</TableCell>
                                        <TableCell>{row.networkName}</TableCell> */}
                                        <TableCell>{row.evaluatorCode}</TableCell>
                                        <TableCell>{row.evaluatorName}</TableCell>
                                        <TableCell>{row.zmCode}</TableCell>
                                        <TableCell>{row.zmName}</TableCell>
                                        <TableCell>{row.rmCode}</TableCell>
                                        <TableCell>{row.rmName}</TableCell>
                                    </TableRow>
                                ))}

                            </TableBody>
                        </Table>
                    </CommanTableContainHierachyMaster>
                </Card>
            </CardContain>
            <TablePagination
                component="div"
                count={totalData}
                page={page}
                onPageChange={(e, newPage) => setPage(newPage)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => setRowsPerPage(parseInt(e.target.value, 10))}
            />
            <ToastContainer />
        </>
    );
};

export default HierachyMaster;
